var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 2.66675H2.66683C2.31321 2.66675 1.97407 2.80722 1.72402 3.05727C1.47397 3.30732 1.3335 3.64646 1.3335 4.00008V13.3334C1.3335 13.687 1.47397 14.0262 1.72402 14.2762C1.97407 14.5263 2.31321 14.6667 2.66683 14.6667H12.0002C12.3538 14.6667 12.6929 14.5263 12.943 14.2762C13.193 14.0262 13.3335 13.687 13.3335 13.3334V8.66675M12.3335 1.66665C12.5987 1.40144 12.9584 1.25244 13.3335 1.25244C13.7086 1.25244 14.0683 1.40144 14.3335 1.66665C14.5987 1.93187 14.7477 2.29158 14.7477 2.66665C14.7477 3.04173 14.5987 3.40144 14.3335 3.66666L8.00016 9.99999L5.3335 10.6667L6.00016 7.99999L12.3335 1.66665Z",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.af036209ef4859662b473195b603560e.svg";
export { ForwardRef as ReactComponent };